import tinycolor from "tinycolor2";

// This is a function that adjusts a foreground color to ensure it has sufficient contrast against the background color.
// It lightens or darkens the foreground color as needed to meet the target contrast ratio by modifying the luminence of
// the color in the HSL colorspace, while maintaining the original hue and saturation.
export function adjustColorContrast(
    foregroundColor: string,
    backgroundColor: string,
    targetContrast: number = 4.5
): string {
    const background = tinycolor(backgroundColor);
    let foreground = tinycolor(foregroundColor);

    // If already meets contrast, return as is
    if (tinycolor.readability(background, foreground) >= targetContrast) {
        return foreground.toHexString();
    }

    // Try lightening and darkening the foreground color
    let bestForeground = foreground;
    let bestContrast = tinycolor.readability(background, foreground);

    // Try lightening
    for (let adjustAmount = 1; adjustAmount <= 100; adjustAmount++) {
        let testForeground = foreground.clone().lighten(adjustAmount);
        let contrast = tinycolor.readability(background, testForeground);
        if (contrast >= targetContrast) {
            return testForeground.toHexString();
        }
        if (contrast > bestContrast) {
            bestContrast = contrast;
            bestForeground = testForeground;
        }
    }

    // Try darkening
    for (let adjustAmount = 1; adjustAmount <= 100; adjustAmount++) {
        let testForeground = foreground.clone().darken(adjustAmount);
        let contrast = tinycolor.readability(background, testForeground);
        if (contrast >= targetContrast) {
            return testForeground.toHexString();
        }
        if (contrast > bestContrast) {
            bestContrast = contrast;
            bestForeground = testForeground;
        }
    }

    // Return the color with the best contrast found
    return bestForeground.toHexString();
}
